import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from '@material-ui/core';
import Masonry from 'react-masonry-component';
import { COLORS } from '../../styles';
import Shoutout from '../../components/Shoutout';
import './Shoutouts.scss';
import SendShoutout from '../../components/SendShoutout';
import { setShowSendShoutoutModal } from '../../actions/HotkeyActions';
import { setShowComments, setShowDeleteComment, deleteComment } from '../../actions/CommentsActions';
import { showToast, hideToast } from '../../actions/ToastActions';
import { getShoutoutById, getShoutouts, initShoutoutsFeed } from '../../actions/ShoutoutsActions';
import { Modal, Comments, DotLoader } from '../../components';
import ShoutoutNotFoundModal from '../../components/ShoutoutNotFoundModal';

class Shoutouts extends Component {
  constructor() {
    super();
    this.scrollListener = this.scrollListener.bind(this);
  }

  listener = null;
  preventLoading = false;
  waitingForShoutout = false;
  backToTopStartHeight = window.innerHeight * 2;
  state = { showError: false };
  // Needs to be a fat arrow function for proper binding and removing of the listener
  scrollListener = () => {
    let toTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (toTop + document.documentElement.clientHeight > document.body.clientHeight - 80) {
      if (!this.preventLoading) {
        this.preventLoading = true;
        setTimeout(() => {
          this.props.getShoutouts();
          setTimeout(() => this.preventLoading = false, 1000);
        }, 2000);
      }
    }


    if (toTop > this.backToTopStartHeight && !this.props.shown) {
      const toastContent = this.renderBackToTop();
      this.props.showToast(toastContent, null, false);
    } else if (toTop <= this.backToTopStartHeight && this.props.shown) {
      this.props.hideToast();
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', this.scrollListener);
  }

  componentWillUnmount() {
    if (this.scrollListener) {
      document.removeEventListener('scroll', this.scrollListener);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const id = nextProps.match.params.id;
    if (id && nextProps.shoutouts.length) {
      let shoutout = nextProps.shoutouts.filter(shoutout => shoutout._id === id);
      if (shoutout.length > 0) {
        this.props.setShowComments(shoutout[0]);
      } else if (!this.waitingForShoutout) {
        this.waitingForShoutout = true;
        this.gettingShoutout(id);
        shoutout = nextProps.shoutouts.filter(shoutout => shoutout._id === id);
        if ((!shoutout || !shoutout.length) && id !== undefined) this.setState({ showError: true });
      } else {
        if (id !== undefined) this.setState({ showError: true });
        this.props.history.push('/shoutouts');
      }
    } else {
      this.props.setShowComments(null);
    }
  }

  async gettingShoutout(id) {
    await this.props.getShoutoutById(id);
  }

  renderBackToTopContent(){
    if (window.innerWidth <= 480) {
      return (
        <div>
          <Icon>play_arrow</Icon>
          <div className="back-to-top-text">Top</div>
        </div>
      );
    }
    else {
      return (
        <div>
          <Icon>play_arrow</Icon>
          <div className="back-to-top-text">Back to top</div>
        </div>
      );
    }
  }

  renderBackToTop() {
    return (
      <div onClick={() => {
        if (document.documentElement.scrollTop !== 0) document.documentElement.scrollTop = 0;
        if (document.body.scrollTop !== 0) document.body.scrollTop = 0;
      }}
      className="back-to-top-content">
        {this.renderBackToTopContent()}
      </div>
    );
  }

  renderShoutouts() {
    const { shoutouts } = this.props;
    return (
      shoutouts.map((shoutout, i) => (
        <Shoutout
          key={shoutout.date}
          shoutout={shoutout}
          color={COLORS[i % COLORS.length]}
          commentClick={shoutout => this.props.history.push(`/shoutouts/${shoutout._id}`)}
        />
      ))
    );
  }


  renderLoader() {
    const { allShoutoutsLoaded } = this.props;
    if (allShoutoutsLoaded) {
      return (
        <div className="all-loaded">
          NO MORE SHOUTOUTS TO LOAD
        </div>
      );
    }
    return <DotLoader label="LOADING MORE SHOUTOUTS" />;
  }

  render() {
    const { showComments } = this.props;
    return (
      <div className="feed-parent" style={{ margin: 'auto', marginTop: 40 }}>
        <div className="feed-wrapper">

          <Masonry
            ref={(ref) => this.gallery = ref}
            className="gallery" // default ''
            id="gallery"
            enableResizableChildren={true}
            disableImagesLoaded={false} // default false
            options={{ gutter: 25, columnWidth: 430 }}
            updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
          >
            <SendShoutout onHeightChange={() => setTimeout(() => this.gallery.performLayout(), 5)}/>
            {this.renderShoutouts()}
          </Masonry>
        </div>

        {this.renderLoader()}

        <Modal header="Shoutout Comments" className="comments-modal" showModal={showComments}
          closeModal={() => this.props.history.push('/shoutouts')} width="700px"
        >
          <Comments closeModal={() => this.props.history.push('/shoutouts')} shoutout={showComments} />
        </Modal>


        <ShoutoutNotFoundModal showError={this.state.showError} onClose={() => {
          this.props.history.push('/shoutouts');
          this.setState({ showError: false });
        } }/>

      </div>
    );
  }
}

const mapStateToProps = ({ shoutoutsStore, hotkeyStore, commentsStore, toastStore, usersStore }) => {
  const { shoutouts, allShoutoutsLoaded } = shoutoutsStore;
  const { currentUser } = usersStore;
  const { isFocus, showSend } = hotkeyStore;
  const { showComments, showDeleteComment } = commentsStore;
  const { shown } = toastStore;
  const sortedShoutouts = shoutouts.sort((a, b) => new Date(b.date) - new Date(a.date));
  return { shoutouts: sortedShoutouts, allShoutoutsLoaded, isFocus, showSend, showComments, showDeleteComment, shown, currentUser };
};

export default connect(mapStateToProps, { getShoutoutById, getShoutouts, initShoutoutsFeed,
  setShowSendShoutoutModal, setShowComments, setShowDeleteComment, showToast, hideToast, deleteComment })(Shoutouts);



// WEBPACK FOOTER //
// ./src/screens/shoutouts/Shoutouts.js